import {exibirMensagem, HttpVerbo, xfetch} from "../util";
import {Delegacia} from "../tipos/delegacia";
import {DelegaciaCmd} from "../tipos/cmd/delegacia-cmd";

const url = '/delegacia'

export default class DelegaciaServico {

  static listarDelegacias = async (): Promise<Delegacia[]> => {
    let res =
      await xfetch(url, {}, HttpVerbo.GET)
        .catch(e => alert(e.message))
    return res.json();
  }

  static salvarDelegacia(dados: DelegaciaCmd) {
    return xfetch(url, dados, HttpVerbo.POST).catch(e => exibirMensagem(e.message))
  }
  static alterarDelegacia(dados: DelegaciaCmd) {
    return xfetch(url, dados, HttpVerbo.PUT).catch(e => exibirMensagem(e.message))
  }
}
